import i18n from "i18next";
import detector from "i18next-browser-languagedetector";
import { initReactI18next } from "react-i18next";
import Form001EN from "./locales/Form001/Form001EN";
import Form001PICSEN from "./locales/Form001/Form001PICSEN";
import Form002PICSSC from "./locales/Form002/Form002PICSSC";
import Form002PICSTC from "./locales/Form002/Form002PICSTC";
import Form002SC from "./locales/Form002/Form002SC";
import Form002TC from "./locales/Form002/Form002TC";
import Form002ASC from "./locales/Form002A/Form002ASC";
import Form002ATC from "./locales/Form002A/Form002ATC";
import Form003EN from "./locales/Form003/Form003EN";
import Form003PICSEN from "./locales/Form003/Form003PICSEN";
import Form003PICSSC from "./locales/Form003/Form003PICSSC";
import Form003PICSTC from "./locales/Form003/Form003PICSTC";
import Form003SC from "./locales/Form003/Form003SC";
import Form003TC from "./locales/Form003/Form003TC";
import Form004EN from "./locales/Form004/Form004EN";
import Form004PICSEN from "./locales/Form004/Form004PICSEN";
import Form004PICSTC from "./locales/Form004/Form004PICSTC";
import Form004TC from "./locales/Form004/Form004TC";
import Form005EN from "./locales/Form005/Form005EN";
import Form005PICSEN from "./locales/Form005/Form005PICSEN";
import Form005PICSTC from "./locales/Form005/Form005PICSTC";
import Form005TC from "./locales/Form005/Form005TC";
import Form006EN from "./locales/Form006/Form006EN";
import Form006PICSEN from "./locales/Form006/Form006PICSEN";
import Form006PICSTC from "./locales/Form006/Form006PICSTC";
import Form006TC from "./locales/Form006/Form006TC";
import Form007EN from "./locales/Form007/Form007EN";
import Form007PICSEN from "./locales/Form007/Form007PICSEN";
import Form007PICSSC from "./locales/Form007/Form007PICSSC";
import Form007PICSTC from "./locales/Form007/Form007PICSTC";
import Form007SC from "./locales/Form007/Form007SC";
import Form007TC from "./locales/Form007/Form007TC";
import Form008PICSSC from "./locales/Form008/Form008PICSSC";
import Form008PICSTC from "./locales/Form008/Form008PICSTC";
import Form008SC from "./locales/Form008/Form008SC";
import Form008TC from "./locales/Form008/Form008TC";
import Form009PICSSC from "./locales/Form009/Form009PICSSC";
import Form009PICSTC from "./locales/Form009/Form009PICSTC";
import Form009SC from "./locales/Form009/Form009SC";
import Form009TC from "./locales/Form009/Form009TC";
import Form010EN from "./locales/Form010/Form010EN";
import Form010PICSEN from "./locales/Form010/Form010PICSEN";
import Form010PICSSC from "./locales/Form010/Form010PICSSC";
import Form010PICSTC from "./locales/Form010/Form010PICSTC";
import Form010SC from "./locales/Form010/Form010SC";
import Form010TC from "./locales/Form010/Form010TC";
import Form011EN from "./locales/Form011/Form011EN";
import Form011PICSEN from "./locales/Form011/Form011PICSEN";
import Form011PICSSC from "./locales/Form011/Form011PICSSC";
import Form011PICSTC from "./locales/Form011/Form011PICSTC";
import Form011SC from "./locales/Form011/Form011SC";
import Form011TC from "./locales/Form011/Form011TC";
import Form012EN from "./locales/Form012/Form012EN";
import Form012PICSEN from "./locales/Form012/Form012PICSEN";
import Form012PICSTC from "./locales/Form012/Form012PICSTC";
import Form012TC from "./locales/Form012/Form012TC";
import Form013EN from "./locales/Form013/Form013EN";
import Form013PICSEN from "./locales/Form013/Form013PICSEN";
import Form013PICSTC from "./locales/Form013/Form013PICSTC";
import Form013TC from "./locales/Form013/Form013TC";
import Form014EN from "./locales/Form014/Form014EN";
import Form014PICSEN from "./locales/Form014/Form014PICSEN";
import Form014PICSSC from "./locales/Form014/Form014PICSSC";
import Form014PICSTC from "./locales/Form014/Form014PICSTC";
import Form014SC from "./locales/Form014/Form014SC";
import Form014TC from "./locales/Form014/Form014TC";
import Form015EN from "./locales/Form015/Form015EN";
import Form015PICSEN from "./locales/Form015/Form015PICSEN";
import Form015PICSSC from "./locales/Form015/Form015PICSSC";
import Form015PICSTC from "./locales/Form015/Form015PICSTC";
import Form015SC from "./locales/Form015/Form015SC";
import Form015TC from "./locales/Form015/Form015TC";
import Form016EN from "./locales/Form016/Form016EN";
import Form016PICSEN from "./locales/Form016/Form016PICSEN";
import Form016PICSSC from "./locales/Form016/Form016PICSSC";
import Form016PICSTC from "./locales/Form016/Form016PICSTC";
import Form016SC from "./locales/Form016/Form016SC";
import Form016TC from "./locales/Form016/Form016TC";
import Form017EN from "./locales/Form017/Form017EN";
import Form017PICSEN from "./locales/Form017/Form017PICSEN";
import Form017PICSSC from "./locales/Form017/Form017PICSSC";
import Form017PICSTC from "./locales/Form017/Form017PICSTC";
import Form017SC from "./locales/Form017/Form017SC";
import Form017TC from "./locales/Form017/Form017TC";
import Form018EN from "./locales/Form018/Form018EN";
import Form018PICSEN from "./locales/Form018/Form018PICSEN";
import Form018PICSSC from "./locales/Form018/Form018PICSSC";
import Form018PICSTC from "./locales/Form018/Form018PICSTC";
import Form018SC from "./locales/Form018/Form018SC";
import Form018TC from "./locales/Form018/Form018TC";
import Form019EN from "./locales/Form019/Form019EN";
import Form019PICSEN from "./locales/Form019/Form019PICSEN";
import Form021EN from "./locales/Form021/Form021EN";
import Form021PICSEN from "./locales/Form021/Form021PICSEN";
import Form022EN from "./locales/Form022/Form022EN";
import Form022PICSEN from "./locales/Form022/Form022PICSEN";
import Form023EN from "./locales/Form023/Form023EN";
import Form023PICSEN from "./locales/Form023/Form023PICSEN";
import Form023AEN from "./locales/Form023A/Form023AEN";
import Form026EN from "./locales/Form026/Form026EN";
import Form026PICSEN from "./locales/Form026/Form026PICSEN";
import Form027EN from "./locales/Form027/Form027EN";
import Form027PICSEN from "./locales/Form027/Form027PICSEN";
import Form027PICSTC from "./locales/Form027/Form027PICSTC";
import Form027TC from "./locales/Form027/Form027TC";
import Form028EN from "./locales/Form028/Form028EN";
import Form028PICSEN from "./locales/Form028/Form028PICSEN";
import Form028PICSSC from "./locales/Form028/Form028PICSSC";
import Form028PICSTC from "./locales/Form028/Form028PICSTC";
import Form028SC from "./locales/Form028/Form028SC";
import Form028TC from "./locales/Form028/Form028TC";
import Form029EN from "./locales/Form029/Form029EN";
import Form029PICSEN from "./locales/Form029/Form029PICSEN";
import Form029PICSSC from "./locales/Form029/Form029PICSSC";
import Form029PICSTC from "./locales/Form029/Form029PICSTC";
import Form029SC from "./locales/Form029/Form029SC";
import Form029TC from "./locales/Form029/Form029TC";
import Form030EN from "./locales/Form030/Form030EN";
import Form030PICSEN from "./locales/Form030/Form030PICSEN";
import Form031EN from "./locales/Form031/Form031EN";
import Form031PICSEN from "./locales/Form031/Form031PICSEN";
import Form031AEN from "./locales/Form031A/Form031AEN";
import Form032EN from "./locales/Form032/Form032EN";
import Form032PICSEN from "./locales/Form032/Form032PICSEN";
import Form033EN from "./locales/Form033/Form033EN";
import Form033PICSEN from "./locales/Form033/Form033PICSEN";
import Form034EN from "./locales/Form034/Form034EN";
import Form034PICSEN from "./locales/Form034/Form034PICSEN";
import Form035EN from "./locales/Form035/Form035EN";
import Form035PICSEN from "./locales/Form035/Form035PICSEN";
import Form040EN from "./locales/Form040/Form040EN";
import Form040PICSEN from "./locales/Form040/Form040PICSEN";
import Form040PICSTC from "./locales/Form040/Form040PICSTC";
import Form040SC from "./locales/Form040/Form040SC";
import Form040TC from "./locales/Form040/Form040TC";
import Form041EN from "./locales/Form041/Form041EN";
import Form041PICSEN from "./locales/Form041/Form041PICSEN";
import Form041PICSTC from "./locales/Form041/Form041PICSTC";
import Form041SC from "./locales/Form041/Form041SC";
import Form041TC from "./locales/Form041/Form041TC";
import Form042EN from "./locales/Form042/Form042EN";
import Form042PICSEN from "./locales/Form042/Form042PICSEN";
import Form042PICSTC from "./locales/Form042/Form042PICSTC";
import Form042TC from "./locales/Form042/Form042TC";
import Form043EN from "./locales/Form043/Form043EN";
import Form043PICSEN from "./locales/Form043/Form043PICSEN";
import Form043PICSTC from "./locales/Form043/Form043PICSTC";
import Form043TC from "./locales/Form043/Form043TC";
import Form044EN from "./locales/Form044/Form044EN";
import Form044PICSEN from "./locales/Form044/Form044PICSEN";
import Form044PICSTC from "./locales/Form044/Form044PICSTC";
import Form044TC from "./locales/Form044/Form044TC";
import Form045EN from "./locales/Form045/Form045EN";
import Form045PICSEN from "./locales/Form045/Form045PICSEN";
import Form045PICSTC from "./locales/Form045/Form045PICSTC";
import Form045TC from "./locales/Form045/Form045TC";
import Form046EN from "./locales/Form046/Form046EN";
import Form046PICSEN from "./locales/Form046/Form046PICSEN";
import Form046PICSTC from "./locales/Form046/Form046PICSTC";
import Form046TC from "./locales/Form046/Form046TC";
import Form047EN from "./locales/Form047/Form047EN";
import Form047PICSEN from "./locales/Form047/Form047PICSEN";
import Form047PICSTC from "./locales/Form047/Form047PICSTC";
import Form047TC from "./locales/Form047/Form047TC";
import Form048EN from "./locales/Form048/Form048EN";
import Form048PICSEN from "./locales/Form048/Form048PICSEN";
import Form048PICSTC from "./locales/Form048/Form048PICSTC";
import Form048TC from "./locales/Form048/Form048TC";
import Form049EN from "./locales/Form049/Form049EN";
import Form049PICSEN from "./locales/Form049/Form049PICSEN";
import Form049PICSTC from "./locales/Form049/Form049PICSTC";
import Form049TC from "./locales/Form049/Form049TC";
import Form050EN from "./locales/Form050/Form050EN";
import Form050PICSEN from "./locales/Form050/Form050PICSEN";
import Form050PICSTC from "./locales/Form050/Form050PICSTC";
import Form050TC from "./locales/Form050/Form050TC";
import Form051EN from "./locales/Form051/Form051EN";
import Form051PICSEN from "./locales/Form051/Form051PICSEN";
import Form051PICSSC from "./locales/Form051/Form051PICSSC";
import Form051PICSTC from "./locales/Form051/Form051PICSTC";
import Form051SC from "./locales/Form051/Form051SC";
import Form051TC from "./locales/Form051/Form051TC";
import Form052EN from "./locales/Form052/Form052EN";
import Form052PICSEN from "./locales/Form052/Form052PICSEN";
import Form052PICSSC from "./locales/Form052/Form052PICSSC";
import Form052PICSTC from "./locales/Form052/Form052PICSTC";
import Form052SC from "./locales/Form052/Form052SC";
import Form052TC from "./locales/Form052/Form052TC";
import Form053EN from "./locales/Form053/Form053EN";
import Form053PICSEN from "./locales/Form053/Form053PICSEN";
import Form053PICSSC from "./locales/Form053/Form053PICSSC";
import Form053PICSTC from "./locales/Form053/Form053PICSTC";
import Form053SC from "./locales/Form053/Form053SC";
import Form053TC from "./locales/Form053/Form053TC";
import Form054EN from "./locales/Form054/Form054EN";
import Form054PICSEN from "./locales/Form054/Form054PICSEN";
import Form054PICSSC from "./locales/Form054/Form054PICSSC";
import Form054PICSTC from "./locales/Form054/Form054PICSTC";
import Form054SC from "./locales/Form054/Form054SC";
import Form054TC from "./locales/Form054/Form054TC";
import Form057EN from "./locales/Form057/Form057EN";
import Form057PICSEN from "./locales/Form057/Form057PICSEN";
import Form057PICSSC from "./locales/Form057/Form057PICSSC";
import Form057PICSTC from "./locales/Form057/Form057PICSTC";
import Form057SC from "./locales/Form057/Form057SC";
import Form057TC from "./locales/Form057/Form057TC";
import Form058EN from "./locales/Form058/Form058EN";
import Form058PICSEN from "./locales/Form058/Form058PICSEN";
import Form058PICSTC from "./locales/Form058/Form058PICSTC";
import Form058TC from "./locales/Form058/Form058TC";
import Form059EN from "./locales/Form059/Form059EN";
import Form059PICSEN from "./locales/Form059/Form059PICSEN";
import Form059PICSSC from "./locales/Form059/Form059PICSSC";
import Form059PICSTC from "./locales/Form059/Form059PICSTC";
import Form059SC from "./locales/Form059/Form059SC";
import Form059TC from "./locales/Form059/Form059TC";
import Form062EN from "./locales/Form062/Form062EN";
import Form062PICSEN from "./locales/Form062/Form062PICSEN";
import Form062PICSSC from "./locales/Form062/Form062PICSSC";
import Form062PICSTC from "./locales/Form062/Form062PICSTC";
import Form062SC from "./locales/Form062/Form062SC";
import Form062TC from "./locales/Form062/Form062TC";
import Form063EN from "./locales/Form063/Form063EN";
import Form063PICSEN from "./locales/Form063/Form063PICSEN";
import Form063PICSTC from "./locales/Form063/Form063PICSTC";
import Form063TC from "./locales/Form063/Form063TC";
import Form064EN from "./locales/Form064/Form064EN";
import Form064PICSEN from "./locales/Form064/Form064PICSEN";
import Form064PICSTC from "./locales/Form064/Form064PICSTC";
import Form064TC from "./locales/Form064/Form064TC";
import Form065EN from "./locales/Form065/Form065EN";
import Form065PICSEN from "./locales/Form065/Form065PICSEN";
import Form065PICSTC from "./locales/Form065/Form065PICSTC";
import Form065TC from "./locales/Form065/Form065TC";
import Form066EN from "./locales/Form066/Form066EN";
import Form066PICSEN from "./locales/Form066/Form066PICSEN";
import Form066PICSTC from "./locales/Form066/Form066PICSTC";
import Form066TC from "./locales/Form066/Form066TC";
import Form067EN from "./locales/Form067/Form067EN";
import Form067PICSEN from "./locales/Form067/Form067PICSEN";
import Form067PICSTC from "./locales/Form067/Form067PICSTC";
import Form067TC from "./locales/Form067/Form067TC";
import Form068EN from "./locales/Form068/Form068EN";
import Form068PICSEN from "./locales/Form068/Form068PICSEN";
import Form068PICSTC from "./locales/Form068/Form068PICSTC";
import Form068SC from "./locales/Form068/Form068SC";
import Form068TC from "./locales/Form068/Form068TC";
import Form069EN from "./locales/Form069/Form069EN";
import Form069PICSEN from "./locales/Form069/Form069PICSEN";
import Form069PICSSC from "./locales/Form069/Form069PICSSC";
import Form069PICSTC from "./locales/Form069/Form069PICSTC";
import Form069SC from "./locales/Form069/Form069SC";
import Form069TC from "./locales/Form069/Form069TC";
import Form070EN from "./locales/Form070/Form070EN";
import Form070PICSEN from "./locales/Form070/Form070PICSEN";
import Form070PICSSC from "./locales/Form070/Form070PICSSC";
import Form070PICSTC from "./locales/Form070/Form070PICSTC";
import Form070SC from "./locales/Form070/Form070SC";
import Form070TC from "./locales/Form070/Form070TC";
import Form071EN from "./locales/Form071/Form071EN";
import Form071PICSEN from "./locales/Form071/Form071PICSEN";
import Form071PICSTC from "./locales/Form071/Form071PICSTC";
import Form071TC from "./locales/Form071/Form071TC";
import Form072EN from "./locales/Form072/Form072EN";
import Form072PICSEN from "./locales/Form072/Form072PICSEN";
import Form072PICSSC from "./locales/Form072/Form072PICSSC";
import Form072PICSTC from "./locales/Form072/Form072PICSTC";
import Form072SC from "./locales/Form072/Form072SC";
import Form072TC from "./locales/Form072/Form072TC";
import Form073EN from "./locales/Form073/Form073EN";
import Form073PICSEN from "./locales/Form073/Form073PICSEN";
import Form074EN from "./locales/Form074/Form074EN";
import Form074PICSEN from "./locales/Form074/Form074PICSEN";
import Form074PICSSC from "./locales/Form074/Form074PICSSC";
import Form074PICSTC from "./locales/Form074/Form074PICSTC";
import Form074SC from "./locales/Form074/Form074SC";
import Form074TC from "./locales/Form074/Form074TC";
import Form075EN from "./locales/Form075/Form075EN";
import Form075PICSEN from "./locales/Form075/Form075PICSEN";
import Form075PICSTC from "./locales/Form075/Form075PICSTC";
import Form075TC from "./locales/Form075/Form075TC";
import Form076EN from "./locales/Form076/Form076EN";
import Form076PICSEN from "./locales/Form076/Form076PICSEN";
import Form076PICSSC from "./locales/Form076/Form076PICSSC";
import Form076SC from "./locales/Form076/Form076SC";
import Form078EN from "./locales/Form078/Form078EN";
import Form078PICSEN from "./locales/Form078/Form078PICSEN";
import Form078PICSSC from "./locales/Form078/Form078PICSSC";
import Form078PICSTC from "./locales/Form078/Form078PICSTC";
import Form078SC from "./locales/Form078/Form078SC";
import Form078TC from "./locales/Form078/Form078TC";
import Form079EN from "./locales/Form079/Form079EN";
import Form079PICSEN from "./locales/Form079/Form079PICSEN";
import Form079PICSTC from "./locales/Form079/Form079PICSTC";
import Form079TC from "./locales/Form079/Form079TC";
import Form080EN from "./locales/Form080/Form080EN";
import Form080PICSEN from "./locales/Form080/Form080PICSEN";
import Form080PICSSC from "./locales/Form080/Form080PICSSC";
import Form080PICSTC from "./locales/Form080/Form080PICSTC";
import Form080SC from "./locales/Form080/Form080SC";
import Form080TC from "./locales/Form080/Form080TC";
import Form081EN from "./locales/Form081/Form081EN";
import Form081PICSEN from "./locales/Form081/Form081PICSEN";
import Form081PICSSC from "./locales/Form081/Form081PICSSC";
import Form081PICSTC from "./locales/Form081/Form081PICSTC";
import Form081SC from "./locales/Form081/Form081SC";
import Form081TC from "./locales/Form081/Form081TC";
import Form082EN from "./locales/Form082/Form082EN";
import Form082PICSEN from "./locales/Form082/Form082PICSEN";
import Form082PICSSC from "./locales/Form082/Form082PICSSC";
import Form082PICSTC from "./locales/Form082/Form082PICSTC";
import Form082SC from "./locales/Form082/Form082SC";
import Form082TC from "./locales/Form082/Form082TC";
import Form083EN from "./locales/Form083/Form083EN";
import Form083PICSEN from "./locales/Form083/Form083PICSEN";
import Form083PICSTC from "./locales/Form083/Form083PICSTC";
import Form083TC from "./locales/Form083/Form083TC";
import Form084EN from "./locales/Form084/Form084EN";
import Form084PICSEN from "./locales/Form084/Form084PICSEN";
import Form084PICSTC from "./locales/Form084/Form084PICSTC";
import Form084TC from "./locales/Form084/Form084TC";
import Form085EN from "./locales/Form085/Form085EN";
import Form085PICSEN from "./locales/Form085/Form085PICSEN";
import Form085PICSTC from "./locales/Form085/Form085PICSTC";
import Form085TC from "./locales/Form085/Form085TC";
import Form086EN from "./locales/Form086/Form086EN";
import Form086PICSEN from "./locales/Form086/Form086PICSEN";
import Form086PICSTC from "./locales/Form086/Form086PICSTC";
import Form086TC from "./locales/Form086/Form086TC";
import Form087EN from "./locales/Form087/Form087EN";
import Form087TC from "./locales/Form087/Form087TC";
import Form088EN from "./locales/Form088/Form088EN";
import Form088PICSEN from "./locales/Form088/Form088PICSEN";
import Form088PICSTC from "./locales/Form088/Form088PICSTC";
import Form088TC from "./locales/Form088/Form088TC";
import Form089EN from "./locales/Form089/Form089EN";
import Form089PICSEN from "./locales/Form089/Form089PICSEN";
import Form089PICSTC from "./locales/Form089/Form089PICSTC";
import Form089TC from "./locales/Form089/Form089TC";
import Form090EN from "./locales/Form090/Form090EN";
import Form090PICSEN from "./locales/Form090/Form090PICSEN";
import Form090PICSSC from "./locales/Form090/Form090PICSSC";
import Form090PICSTC from "./locales/Form090/Form090PICSTC";
import Form090SC from "./locales/Form090/Form090SC";
import Form090TC from "./locales/Form090/Form090TC";
import Form091EN from "./locales/Form091/Form091EN";
import Form091PICSEN from "./locales/Form091/Form091PICSEN";
import Form091PICSSC from "./locales/Form091/Form091PICSSC";
import Form091PICSTC from "./locales/Form091/Form091PICSTC";
import Form091SC from "./locales/Form091/Form091SC";
import Form091TC from "./locales/Form091/Form091TC";
import Form092EN from "./locales/Form092/Form092EN";
import Form092PICSEN from "./locales/Form092/Form092PICSEN";
import Form092PICSSC from "./locales/Form092/Form092PICSSC";
import Form092PICSTC from "./locales/Form092/Form092PICSTC";
import Form092SC from "./locales/Form092/Form092SC";
import Form092TC from "./locales/Form092/Form092TC";
import Form093EN from "./locales/Form093/Form093EN";
import Form093PICSEN from "./locales/Form093/Form093PICSEN";
import Form093PICSTC from "./locales/Form093/Form093PICSTC";
import Form093TC from "./locales/Form093/Form093TC";
import Form094EN from "./locales/Form094/Form094EN";
import Form094PICSEN from "./locales/Form094/Form094PICSEN";
import Form094PICSTC from "./locales/Form094/Form094PICSTC";
import Form094TC from "./locales/Form094/Form094TC";
import Form095EN from "./locales/Form095/Form095EN";
import Form095PICSEN from "./locales/Form095/Form095PICSEN";
import Form095PICSTC from "./locales/Form095/Form095PICSTC";
import Form095TC from "./locales/Form095/Form095TC";
import Form096EN from "./locales/Form096/Form096EN";
import Form096PICSEN from "./locales/Form096/Form096PICSEN";
import Form096PICSTC from "./locales/Form096/Form096PICSTC";
import Form096TC from "./locales/Form096/Form096TC";
import Form097EN from "./locales/Form097/Form097EN";
import Form098EN from "./locales/Form098/Form098EN";
import Form098PICSEN from "./locales/Form098/Form098PICSEN";
import Form099EN from "./locales/Form099/Form099EN";
import Form099PICSEN from "./locales/Form099/Form099PICSEN";
import Form099PICSTC from "./locales/Form099/Form099PICSTC";
import Form099TC from "./locales/Form099/Form099TC";
import Form100EN from "./locales/Form100/Form100EN";
import Form100PICSEN from "./locales/Form100/Form100PICSEN";
import Form100PICSSC from "./locales/Form100/Form100PICSSC";
import Form100PICSTC from "./locales/Form100/Form100PICSTC";
import Form100SC from "./locales/Form100/Form100SC";
import Form100TC from "./locales/Form100/Form100TC";
import Form101EN from "./locales/Form101/Form101EN";
import Form101PICSEN from "./locales/Form101/Form101PICSEN";
import Form101PICSSC from "./locales/Form101/Form101PICSSC";
import Form101PICSTC from "./locales/Form101/Form101PICSTC";
import Form101SC from "./locales/Form101/Form101SC";
import Form101TC from "./locales/Form101/Form101TC";
import Form102EN from "./locales/Form102/Form102EN";
import Form102PICSEN from "./locales/Form102/Form102PICSEN";
import Form102PICSTC from "./locales/Form102/Form102PICSTC";
import Form102TC from "./locales/Form102/Form102TC";
import Form103EN from "./locales/Form103/Form103EN";
import Form103PICSEN from "./locales/Form103/Form103PICSEN";
import Form103PICSSC from "./locales/Form103/Form103PICSSC";
import Form103PICSTC from "./locales/Form103/Form103PICSTC";
import Form103SC from "./locales/Form103/Form103SC";
import Form103TC from "./locales/Form103/Form103TC";
import Form104EN from "./locales/Form104/Form104EN";
import Form104PICSEN from "./locales/Form104/Form104PICSEN";
import Form104PICSTC from "./locales/Form104/Form104PICSTC";
import Form104TC from "./locales/Form104/Form104TC";
import Form105EN from "./locales/Form105/Form105EN";
import Form105SC from "./locales/Form105/Form105SC";
import Form105TC from "./locales/Form105/Form105TC";
import Form106EN from "./locales/Form106/Form106EN";
import Form106PICSEN from "./locales/Form106/Form106PICSEN";
import Form106PICSSC from "./locales/Form106/Form106PICSSC";
import Form106PICSTC from "./locales/Form106/Form106PICSTC";
import Form106SC from "./locales/Form106/Form106SC";
import Form106TC from "./locales/Form106/Form106TC";
import Form107EN from "./locales/Form107/Form107EN";
import Form107PICSEN from "./locales/Form107/Form107PICSEN";
import translationEN from "./locales/common/translationEN.json";
import translationSC from "./locales/common/translationSC.json";
import translationTC from "./locales/common/translationTC.json";
import sampleEN from "./locales/sample/sampleEN";
import sampleSC from "./locales/sample/sampleSC";
import sampleTC from "./locales/sample/sampleTC";

// the translations
const resources = {
    en: {
        translation: {
            ...translationEN,
            sample: sampleEN,
            Form001: Form001EN,
            Form001PICS: Form001PICSEN,
            Form003: Form003EN,
            Form003PICS: Form003PICSEN,
            Form004: Form004EN,
            Form004PICS: Form004PICSEN,
            Form005: Form005EN,
            Form005PICS: Form005PICSEN,
            Form006: Form006EN,
            Form006PICS: Form006PICSEN,
            Form007: Form007EN,
            Form007PICS: Form007PICSEN,
            Form010: Form010EN,
            Form010PICS: Form010PICSEN,
            Form011: Form011EN,
            Form011PICS: Form011PICSEN,
            Form012: Form012EN,
            Form012PICS: Form012PICSEN,
            Form013: Form013EN,
            Form013PICS: Form013PICSEN,
            Form014: Form014EN,
            Form014PICS: Form014PICSEN,
            Form015: Form015EN,
            Form015PICS: Form015PICSEN,
            Form016: Form016EN,
            Form016PICS: Form016PICSEN,
            Form017: Form017EN,
            Form017PICS: Form017PICSEN,
            Form018: Form018EN,
            Form018PICS: Form018PICSEN,
            Form019: Form019EN,
            Form019PICS: Form019PICSEN,
            Form021: Form021EN,
            Form021PICS: Form021PICSEN,
            Form022: Form022EN,
            Form022PICS: Form022PICSEN,
            Form023: Form023EN,
            Form023PICS: Form023PICSEN,
            Form023A: Form023AEN,
            Form026: Form026EN,
            Form026PICS: Form026PICSEN,
            Form027: Form027EN,
            Form027PICS: Form027PICSEN,
            Form028: Form028EN,
            Form028PICS: Form028PICSEN,
            Form029: Form029EN,
            Form029PICS: Form029PICSEN,
            Form030: Form030EN,
            Form030PICS: Form030PICSEN,
            Form031: Form031EN,
            Form031PICS: Form031PICSEN,
            Form031A: Form031AEN,
            Form032PICS: Form032PICSEN,
            Form032: Form032EN,
            Form033: Form033EN,
            Form033PICS: Form033PICSEN,
            Form034: Form034EN,
            Form034PICS: Form034PICSEN,
            Form035: Form035EN,
            Form035PICS: Form035PICSEN,
            Form040: Form040EN,
            Form040PICS: Form040PICSEN,
            Form041: Form041EN,
            Form041PICS: Form041PICSEN,
            Form042: Form042EN,
            Form042PICS: Form042PICSEN,
            Form043: Form043EN,
            Form043PICS: Form043PICSEN,
            Form044: Form044EN,
            Form044PICS: Form044PICSEN,
            Form045: Form045EN,
            Form045PICS: Form045PICSEN,
            Form046: Form046EN,
            Form046PICS: Form046PICSEN,
            Form047: Form047EN,
            Form047PICS: Form047PICSEN,
            Form048: Form048EN,
            Form048PICS: Form048PICSEN,
            Form049: Form049EN,
            Form049PICS: Form049PICSEN,
            Form050: Form050EN,
            Form050PICS: Form050PICSEN,
            Form051: Form051EN,
            Form051PICS: Form051PICSEN,
            Form052: Form052EN,
            Form052PICS: Form052PICSEN,
            Form053: Form053EN,
            Form053PICS: Form053PICSEN,
            Form054: Form054EN,
            Form054PICS: Form054PICSEN,
            Form057: Form057EN,
            Form057PICS: Form057PICSEN,
            Form058: Form058EN,
            Form058PICS: Form058PICSEN,
            Form059: Form059EN,
            Form059PICS: Form059PICSEN,
            Form062: Form062EN,
            Form062PICS: Form062PICSEN,
            Form063: Form063EN,
            Form063PICS: Form063PICSEN,
            Form064: Form064EN,
            Form064PICS: Form064PICSEN,
            Form065: Form065EN,
            Form065PICS: Form065PICSEN,
            Form066: Form066EN,
            Form066PICS: Form066PICSEN,
            Form067: Form067EN,
            Form067PICS: Form067PICSEN,
            Form068: Form068EN,
            Form068PICS: Form068PICSEN,
            Form069: Form069EN,
            Form069PICS: Form069PICSEN,
            Form070: Form070EN,
            Form070PICS: Form070PICSEN,
            Form071: Form071EN,
            Form071PICS: Form071PICSEN,
            Form072: Form072EN,
            Form072PICS: Form072PICSEN,
            Form073: Form073EN,
            Form073PICS: Form073PICSEN,
            Form074: Form074EN,
            Form074PICS: Form074PICSEN,
            Form075: Form075EN,
            Form075PICS: Form075PICSEN,
            Form076: Form076EN,
            Form076PICS: Form076PICSEN,
            Form078: Form078EN,
            Form078PICS: Form078PICSEN,
            Form079: Form079EN,
            Form079PICS: Form079PICSEN,
            Form080: Form080EN,
            Form080PICS: Form080PICSEN,
            Form081: Form081EN,
            Form081PICS: Form081PICSEN,
            Form082: Form082EN,
            Form082PICS: Form082PICSEN,
            Form083: Form083EN,
            Form083PICS: Form083PICSEN,
            Form084: Form084EN,
            Form084PICS: Form084PICSEN,
            Form085: Form085EN,
            Form085PICS: Form085PICSEN,
            Form086: Form086EN,
            Form086PICS: Form086PICSEN,
            Form087: Form087EN,
            Form088: Form088EN,
            Form088PICS: Form088PICSEN,
            Form089: Form089EN,
            Form089PICS: Form089PICSEN,
            Form090: Form090EN,
            Form090PICS: Form090PICSEN,
            Form091: Form091EN,
            Form091PICS: Form091PICSEN,
            Form092: Form092EN,
            Form092PICS: Form092PICSEN,
            Form095: Form095EN,
            Form095PICS: Form095PICSEN,
            Form093: Form093EN,
            Form093PICS: Form093PICSEN,
            Form094: Form094EN,
            Form094PICS: Form094PICSEN,
            Form096: Form096EN,
            Form096PICS: Form096PICSEN,
            Form097: Form097EN,
            Form098: Form098EN,
            Form098PICS: Form098PICSEN,
            Form099: Form099EN,
            Form099PICS: Form099PICSEN,
            Form100: Form100EN,
            Form100PICS: Form100PICSEN,
            Form101: Form101EN,
            Form101PICS: Form101PICSEN,
            Form102: Form102EN,
            Form102PICS: Form102PICSEN,
            Form103: Form103EN,
            Form103PICS: Form103PICSEN,
            Form104: Form104EN,
            Form104PICS: Form104PICSEN,
            Form105: Form105EN,
            Form106: Form106EN,
            Form106PICS: Form106PICSEN,
            Form107: Form107EN,
            Form107PICS: Form107PICSEN,
        },
    },
    tc: {
        translation: {
            ...translationTC,
            sample: sampleTC,
            Form002: Form002TC,
            Form002PICS: Form002PICSTC,
            Form002A: Form002ATC,
            Form003: Form003TC,
            Form003PICS: Form003PICSTC,
            Form004: Form004TC,
            Form004PICS: Form004PICSTC,
            Form005: Form005TC,
            Form005PICS: Form005PICSTC,
            Form006: Form006TC,
            Form006PICS: Form006PICSTC,
            Form007: Form007TC,
            Form007PICS: Form007PICSTC,
            Form008: Form008TC,
            Form008PICS: Form008PICSTC,
            Form009: Form009TC,
            Form009PICS: Form009PICSTC,
            Form010: Form010TC,
            Form010PICS: Form010PICSTC,
            Form011: Form011TC,
            Form011PICS: Form011PICSTC,
            Form012: Form012TC,
            Form012PICS: Form012PICSTC,
            Form013: Form013TC,
            Form013PICS: Form013PICSTC,
            Form014: Form014TC,
            Form014PICS: Form014PICSTC,
            Form015: Form015TC,
            Form015PICS: Form015PICSTC,
            Form016: Form016TC,
            Form016PICS: Form016PICSTC,
            Form017: Form017TC,
            Form017PICS: Form017PICSTC,
            Form018: Form018TC,
            Form018PICS: Form018PICSTC,
            Form027: Form027TC,
            Form027PICS: Form027PICSTC,
            Form028: Form028TC,
            Form028PICS: Form028PICSTC,
            Form029: Form029TC,
            Form029PICS: Form029PICSTC,
            Form040: Form040TC,
            Form040PICS: Form040PICSTC,
            Form041: Form041TC,
            Form041PICS: Form041PICSTC,
            Form042: Form042TC,
            Form042PICS: Form042PICSTC,
            Form043: Form043TC,
            Form043PICS: Form043PICSTC,
            Form044: Form044TC,
            Form044PICS: Form044PICSTC,
            Form045: Form045TC,
            Form045PICS: Form045PICSTC,
            Form046: Form046TC,
            Form046PICS: Form046PICSTC,
            Form047: Form047TC,
            Form047PICS: Form047PICSTC,
            Form048: Form048TC,
            Form048PICS: Form048PICSTC,
            Form049: Form049TC,
            Form049PICS: Form049PICSTC,
            Form050: Form050TC,
            Form050PICS: Form050PICSTC,
            Form051: Form051TC,
            Form051PICS: Form051PICSTC,
            Form052: Form052TC,
            Form052PICS: Form052PICSTC,
            Form053: Form053TC,
            Form053PICS: Form053PICSTC,
            Form054: Form054TC,
            Form054PICS: Form054PICSTC,
            Form057: Form057TC,
            Form057PICS: Form057PICSTC,
            Form058: Form058TC,
            Form058PICS: Form058PICSTC,
            Form059: Form059TC,
            Form059PICS: Form059PICSTC,
            Form062: Form062TC,
            Form062PICS: Form062PICSTC,
            Form063: Form063TC,
            Form063PICS: Form063PICSTC,
            Form064: Form064TC,
            Form064PICS: Form064PICSTC,
            Form065: Form065TC,
            Form065PICS: Form065PICSTC,
            Form066: Form066TC,
            Form066PICS: Form066PICSTC,
            Form067: Form067TC,
            Form067PICS: Form067PICSTC,
            Form068: Form068TC,
            Form068PICS: Form068PICSTC,
            Form069: Form069TC,
            Form069PICS: Form069PICSTC,
            Form070: Form070TC,
            Form070PICS: Form070PICSTC,
            Form071: Form071TC,
            Form071PICS: Form071PICSTC,
            Form072: Form072TC,
            Form072PICS: Form072PICSTC,
            Form074: Form074TC,
            Form074PICS: Form074PICSTC,
            Form075: Form075TC,
            Form075PICS: Form075PICSTC,
            Form078: Form078TC,
            Form078PICS: Form078PICSTC,
            Form079: Form079TC,
            Form079PICS: Form079PICSTC,
            Form080: Form080TC,
            Form080PICS: Form080PICSTC,
            Form081: Form081TC,
            Form081PICS: Form081PICSTC,
            Form082: Form082TC,
            Form082PICS: Form082PICSTC,
            Form083: Form083TC,
            Form083PICS: Form083PICSTC,
            Form084: Form084TC,
            Form084PICS: Form084PICSTC,
            Form085: Form085TC,
            Form085PICS: Form085PICSTC,
            Form086: Form086TC,
            Form086PICS: Form086PICSTC,
            Form087: Form087TC,
            Form088: Form088TC,
            Form088PICS: Form088PICSTC,
            Form089: Form089TC,
            Form089PICS: Form089PICSTC,
            Form090: Form090TC,
            Form090PICS: Form090PICSTC,
            Form091: Form091TC,
            Form091PICS: Form091PICSTC,
            Form092: Form092TC,
            Form092PICS: Form092PICSTC,
            Form093PICS: Form093PICSTC,
            Form095: Form095TC,
            Form095PICS: Form095PICSTC,
            Form093: Form093TC,
            Form094: Form094TC,
            Form094PICS: Form094PICSTC,
            Form096: Form096TC,
            Form096PICS: Form096PICSTC,
            Form099: Form099TC,
            Form099PICS: Form099PICSTC,
            Form100: Form100TC,
            Form100PICS: Form100PICSTC,
            Form101: Form101TC,
            Form101PICS: Form101PICSTC,
            Form102: Form102TC,
            Form102PICS: Form102PICSTC,
            Form103: Form103TC,
            Form103PICS: Form103PICSTC,
            Form104: Form104TC,
            Form104PICS: Form104PICSTC,
            Form105: Form105TC,
            Form106: Form106TC,
            Form106PICS: Form106PICSTC,
        },
    },
    sc: {
        translation: {
            ...translationSC,
            sample: sampleSC,
            Form002: Form002SC,
            Form002A: Form002ASC,
            Form002PICS: Form002PICSSC,
            Form003: Form003SC,
            Form003PICS: Form003PICSSC,
            Form007: Form007SC,
            Form007PICS: Form007PICSSC,
            Form008: Form008SC,
            Form008PICS: Form008PICSSC,
            Form009: Form009SC,
            Form009PICS: Form009PICSSC,
            Form010: Form010SC,
            Form010PICS: Form010PICSSC,
            Form011: Form011SC,
            Form011PICS: Form011PICSSC,
            Form014: Form014SC,
            Form014PICS: Form014PICSSC,
            Form015: Form015SC,
            Form015PICS: Form015PICSSC,
            Form016: Form016SC,
            Form016PICS: Form016PICSSC,
            Form017: Form017SC,
            Form017PICS: Form017PICSSC,
            Form018: Form018SC,
            Form018PICS: Form018PICSSC,
            Form028: Form028SC,
            Form028PICS: Form028PICSSC,
            Form029: Form029SC,
            Form029PICS: Form029PICSSC,
            Form040: Form040SC,
            Form041: Form041SC,
            Form051: Form051SC,
            Form051PICS: Form051PICSSC,
            Form052PICS: Form052PICSSC,
            Form053: Form053SC,
            Form053PICS: Form053PICSSC,
            Form054: Form054SC,
            Form054PICS: Form054PICSSC,
            Form057: Form057SC,
            Form057PICS: Form057PICSSC,
            Form059: Form059SC,
            Form059PICS: Form059PICSSC,
            Form062: Form062SC,
            Form062PICS: Form062PICSSC,
            Form068: Form068SC,
            Form069: Form069SC,
            Form069PICS: Form069PICSSC,
            Form070: Form070SC,
            Form070PICS: Form070PICSSC,
            Form072: Form072SC,
            Form072PICS: Form072PICSSC,
            Form074: Form074SC,
            Form074PICS: Form074PICSSC,
            Form076: Form076SC,
            Form076PICS: Form076PICSSC,
            Form078: Form078SC,
            Form078PICS: Form078PICSSC,
            Form080: Form080SC,
            Form080PICS: Form080PICSSC,
            Form081: Form081SC,
            Form081PICS: Form081PICSSC,
            Form082: Form082SC,
            Form082PICS: Form082PICSSC,
            Form090: Form090SC,
            Form090PICS: Form090PICSSC,
            Form091: Form091SC,
            Form091PICS: Form091PICSSC,
            Form092: Form092SC,
            Form092PICS: Form092PICSSC,
            Form052: Form052SC,
            Form100: Form100SC,
            Form100PICS: Form100PICSSC,
            Form101: Form101SC,
            Form101PICS: Form101PICSSC,
            Form103: Form103SC,
            Form103PICS: Form103PICSSC,
            Form105: Form105SC,
            Form106: Form106SC,
            Form106PICS: Form106PICSSC,
        },
    },
};

i18n.use(detector)
    .use(initReactI18next) // passes i18n down to react-i18next
    .init({
        resources,
        // lng: "en",
        fallbackLng: "en", // use en if detected lng is not available

        interpolation: {
            escapeValue: false, // react already safes from xss
        },
    });

export default i18n;
